module.exports = __webpack_public_path__ + "img/D202001_4.fa4abcd9.jpg";